import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';
import { resolve } from '../../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor(Alert, SharedFoldersResource, ShowNoteModal) {
        this.Alert = Alert;
        this.SharedFoldersResource = SharedFoldersResource;
        this.ShowNoteModal = ShowNoteModal;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    showNote(note){
        this.ShowNoteModal('Note', note.note);
    }

    save() {
        this.isSaving = true;
        this.SharedFoldersResource
            .addCorporateNotes(resolve.companyId, this.resolve.sharedFolder.id, this.st.selectedIds)
            .then(data => {
                this.close();
                this.Alert('success', 'global.messages.operation-successful');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.controller.js